import { useEffect, useState } from "react";

// Registro em módulo: apenas a primeira instância montada de cada chave renderiza,
// evitando duplicação quando os layouts se aninham (ex.: /evento/:id/configuracoes).
const registries = new Map<string, Array<(owner: boolean) => void>>();

/** Garante que apenas a primeira instância montada com essa chave renderize. */
export function useSingleInstance(key: string) {
  const [isOwner, setIsOwner] = useState(false);

  useEffect(() => {
    let list = registries.get(key);
    if (!list) {
      list = [];
      registries.set(key, list);
    }
    const sync = () => list!.forEach((set, i) => set(i === 0));
    list.push(setIsOwner);
    sync();
    return () => {
      const i = list!.indexOf(setIsOwner);
      if (i !== -1) list!.splice(i, 1);
      sync();
    };
  }, [key]);

  return isOwner;
}

export default useSingleInstance;
